// extracted by mini-css-extract-plugin
export default {"root":"LinkedLogo_root__BrSGe","logo":"LinkedLogo_logo__-ZpeB","mobileImageFormat":"LinkedLogo_mobileImageFormat__cT7Ld"};